(() => {
  const intro = document.querySelector('.ff-trade-intro');
  if (!intro || intro.dataset.enhanced) return;
  intro.dataset.enhanced = 'true';
  const mobile = matchMedia('(max-width: 767px)');
  const header = document.querySelector('.xo-header__body');
  const template = document.querySelector('[data-ff-trade-tools]');
  const catalog = JSON.parse(document.querySelector('[data-ff-trade-catalog]')?.textContent || '{}');
  let scheduled = false;
  let summary = null;
  let tools = null;
  let category = 'all';
  let search = '';
  let activePanel = null;
  let activeTrigger = null;
  const backdrop = document.createElement('div');
  backdrop.className = 'ff-trade-backdrop';
  backdrop.hidden = true;
  document.body.append(backdrop);
  const resizeObserver = new ResizeObserver(() => {
    if (header) document.body.style.setProperty('--ff-trade-header-height', `${Math.ceil(header.getBoundingClientRect().height)}px`);
    if (summary) document.body.style.setProperty('--ff-summary-space', `${Math.ceil(summary.getBoundingClientRect().height) + 16}px`);
  });
  if (header) resizeObserver.observe(header);
  const productData = handle => Object.values(catalog).flat().find(product => product.handle === handle);
  const triggerFor = panel => Array.from(panel.previousElementSibling?.querySelectorAll('.samiWS-choose-variant') || []).find(button => button.getBoundingClientRect().width > 0);
  function closePanel(restore = true) {
    const panel = activePanel;
    const trigger = activeTrigger;
    if (panel?.classList.contains('show')) triggerFor(panel)?.click();
    activePanel = null;
    activeTrigger = null;
    backdrop.hidden = true;
    document.body.classList.remove('ff-trade-size-open');
    panel?.removeAttribute('role');
    panel?.removeAttribute('aria-modal');
    if (restore) trigger?.focus({ preventScroll: true });
  }
  backdrop.addEventListener('click', () => closePanel());
  function filterRows(form) {
    const tokens = search.toLowerCase().trim().split(/\s+/).filter(Boolean);
    let count = 0;
    form.querySelectorAll('.samiWS-quickOrder-item').forEach(row => {
      const handle = row.getAttribute('p-handle');
      const product = productData(handle);
      const haystack = `${row.textContent} ${(product?.variants || []).map(variant => variant.title).join(' ')}`.toLowerCase();
      const categoryMatch = category === 'all' || (catalog[category] || []).some(item => item.handle === handle);
      const hidden = mobile.matches && (!categoryMatch || !tokens.every(token => haystack.includes(token)));
      row.toggleAttribute('data-ff-filtered', hidden);
      const variants = row.nextElementSibling;
      if (variants?.classList.contains('variant_product')) variants.toggleAttribute('data-ff-filtered', hidden);
      if (!hidden) count++;
    });
    if (tools) {
      const status = tools.querySelector('.ff-trade-status');
      const label = `${count} ${status.dataset.resultsLabel}`;
      if (status.textContent !== label) status.textContent = label;
      tools.querySelector('.ff-trade-empty').hidden = count > 0;
      tools.querySelector('.ff-trade-clear').hidden = !search;
    }
  }
  function mountTools(form) {
    if (tools || !template || !form.querySelector('.samiWS-quickOrder-item')) return;
    if (form.querySelector('.samitaWS-footer-pagination button:not(:disabled)')) return;
    tools = template.content.firstElementChild.cloneNode(true);
    form.prepend(tools);
    form.classList.add('ff-trade-compact-ready');
    tools.querySelector('input').addEventListener('input', event => {
      search = event.target.value;
      filterRows(form);
    });
    tools.querySelector('input').addEventListener('keydown', event => {
      if (event.key === 'Enter') {
        event.preventDefault();
        event.target.blur();
      }
    });
    tools.querySelector('.ff-trade-clear').addEventListener('click', () => {
      search = '';
      tools.querySelector('input').value = '';
      filterRows(form);
      tools.querySelector('input').focus();
    });
    tools.querySelectorAll('[data-category]').forEach(button => button.addEventListener('click', () => {
      category = button.dataset.category;
      tools.querySelectorAll('[data-category]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      filterRows(form);
      if (tools.getBoundingClientRect().top < 0) tools.scrollIntoView({ block: 'start' });
    }));
  }
  function syncPanels(form) {
    const panels = Array.from(form.querySelectorAll('.variant_product'));
    panels.forEach(panel => {
      if (panel.querySelector('.ff-trade-size-head')) return;
      const cell = panel.firstElementChild;
      if (!cell) return;
      const head = document.createElement('div');
      head.className = 'ff-trade-size-head';
      const title = document.createElement('h2');
      title.textContent = panel.previousElementSibling?.querySelector('.sqvf-product-title')?.textContent.trim() || '';
      const done = document.createElement('button');
      done.type = 'button';
      done.textContent = intro.dataset.doneLabel;
      done.addEventListener('click', () => closePanel());
      head.append(title, done);
      cell.prepend(head);
      panel.setAttribute('aria-label', title.textContent);
    });
    if (!mobile.matches) {
      if (activePanel) closePanel(false);
      return;
    }
    const open = panels.filter(panel => panel.classList.contains('show'));
    const next = open.find(panel => panel !== activePanel) || open[0] || null;
    if (next === activePanel) return;
    const previous = activePanel;
    if (previous && previous !== next) closePanel(false);
    if (next) {
      activePanel = next;
      activeTrigger = triggerFor(next);
      next.setAttribute('role', 'dialog');
      next.setAttribute('aria-modal', 'true');
      backdrop.hidden = false;
      document.body.classList.add('ff-trade-size-open');
      next.querySelector('.ff-trade-size-head button')?.focus({ preventScroll: true });
    } else {
      backdrop.hidden = true;
      document.body.classList.remove('ff-trade-size-open');
    }
  }
  function enhance() {
    scheduled = false;
    const form = document.getElementById('samitaWS_quickOrderForm');
    if (!form) return;
    mountTools(form);
    const currentSummary = form.querySelector('.samiWS-subtotal-block.on-top');
    if (currentSummary && currentSummary !== summary) {
      if (summary) resizeObserver.unobserve(summary);
      summary = currentSummary;
      resizeObserver.observe(summary);
    }
    form.querySelectorAll('.samiWS-quickOrder-item, .samiWS-quickOrder-variant').forEach(row => {
      const name = row.querySelector('.sqvf-product-title')?.textContent.trim() || '';
      row.querySelectorAll('.sqvf-quantity-input').forEach(input => {
        input.setAttribute('aria-label', `${intro.dataset.quantityLabel} ${name}`);
        input.setAttribute('inputmode', 'numeric');
      });
      row.querySelectorAll('.sqvf-quantity-decrease, .sqvf-quantity-increase').forEach(control => {
        const input = control.parentElement.querySelector('input');
        const disabled = Boolean(input?.disabled || control.parentElement.classList.contains('disabled'));
        const prefix = control.classList.contains('sqvf-quantity-increase') ? intro.dataset.increaseLabel : intro.dataset.decreaseLabel;
        control.setAttribute('role', 'button');
        control.setAttribute('aria-label', `${prefix} ${name}`);
        control.setAttribute('aria-disabled', String(disabled));
        control.tabIndex = disabled ? -1 : 0;
      });
      row.querySelectorAll('.samiWS-choose-variant').forEach(button => {
        const target = row.nextElementSibling;
        if (!target?.classList.contains('variant_product')) return;
        const expanded = target.classList.contains('show');
        button.setAttribute('aria-expanded', String(expanded));
        if (target.id) button.setAttribute('aria-controls', target.id);
        const label = button.querySelector(expanded ? '.show-variants__active' : '.show-variants__notactive');
        const text = expanded ? intro.dataset.hideFormatsLabel : intro.dataset.formatsLabel;
        if (label && label.textContent.trim() !== text) label.textContent = text;
      });
      row.querySelectorAll('.samiWS-atc-btn').forEach(button => {
        if (button.dataset.ffLabel) return;
        button.dataset.ffLabel = 'true';
        button.setAttribute('aria-label', `${intro.dataset.addLabel} ${name}`);
        button.textContent = intro.dataset.addLabel;
      });
      if (row.classList.contains('samiWS-quickOrder-item') && !row.querySelector('.ff-trade-pack')) {
        const variant = productData(row.getAttribute('p-handle'))?.variants.find(item => String(item.id) === row.getAttribute('p-variant-id'));
        if (variant && variant.title !== 'Default Title' && !row.querySelector('.samiWS-choose-variant')) {
          const pack = document.createElement('p');
          pack.className = 'ff-trade-pack';
          pack.textContent = variant.title;
          row.querySelector('.sqvf-product-information')?.append(pack);
        }
      }
    });
    form.querySelectorAll('.samiWS-qof-checkout').forEach(button => {
      if (button.dataset.ffLabel) return;
      button.dataset.ffLabel = 'true';
      button.textContent = intro.dataset.checkoutLabel;
    });
    filterRows(form);
    syncPanels(form);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(enhance);
  }
  document.addEventListener('keydown', event => {
    if (activePanel && mobile.matches) {
      if (event.key === 'Escape') { event.preventDefault(); closePanel(); return; }
      if (event.key === 'Tab') {
        const focusable = Array.from(activePanel.querySelectorAll('a, button:not(:disabled), input:not(:disabled), [tabindex="0"]')).filter(element => element.getBoundingClientRect().width > 0);
        const first = focusable[0];
        const last = focusable.at(-1);
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }
    }
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const control = event.target.closest('#samitaWS_quickOrderForm .sqvf-quantity-decrease, #samitaWS_quickOrderForm .sqvf-quantity-increase');
    if (!control) return;
    event.preventDefault();
    if (control.getAttribute('aria-disabled') !== 'true') control.click();
  });
  mobile.addEventListener('change', schedule);
  const content = document.getElementById('xo-main-content');
  if (content) new MutationObserver(schedule).observe(content, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class'] });
  enhance();
})();
